import AuthService from './AuthService';

const baseUrl = (process.env.REACT_APP_CHATBOT_API_URL || process.env.CHATBOT_API_URL || '').replace(/\/+$/, '');

const auditLogService = {
    async list(params, signal) {
        const query = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== '' && value != null) query.set(key, value);
        });
        const loginAs = AuthService.getLoginAs();
        if (loginAs) query.set('loginAs', loginAs);
        const response = await fetch(`${baseUrl}/private/audit-logs?${query}`, {
            headers: { Authorization: `Bearer ${AuthService.getAccessToken()}` }, signal,
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
    },
};
export default auditLogService;
